import { useMutation } from "@tanstack/react-query";
import { createRemindersConfig } from "../actions/create-reminders-config.actions";
import { CreateRemindersConfig } from "../interfaces/create-reminder.interface";
import { useGlobalSnackbar } from "../../../context/SnackbarContext";
import { useQueryClient } from "@tanstack/react-query";
import { remindersQueryKeys } from "../queries/reminders.queries";
import { UpdateReminderConfig } from "../interfaces/update-reminder.interface";
import { updateRemindersConfig } from "../actions/update-reminders.config.actions";
import { deleteRemindersConfig } from "../actions/delete-reminders-config.actions";

export const useRemindersMutation = () => {

    const { showSnackbar } = useGlobalSnackbar()
    const queryClient = useQueryClient();

    const createReminderMutation = useMutation({
        mutationFn: (data: CreateRemindersConfig) => createRemindersConfig(data),
        onSuccess: () => {
            showSnackbar("Reminder created successfully", "success");
            queryClient.invalidateQueries({ queryKey: remindersQueryKeys.all });
        },
        onError: () => {
            showSnackbar("Failed to create reminder", "error");
        },
    });

    const updateReminderMutation = useMutation({
        mutationFn: ({ uid, data }: { uid: string, data: Partial<UpdateReminderConfig> }) => updateRemindersConfig(uid, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: remindersQueryKeys.all });
        },
        onError: () => {
            showSnackbar("Failed to update reminder", "error");
        },
    });

    const deleteReminderMutation = useMutation({
        mutationFn: (uid: string) => deleteRemindersConfig(uid),
        onSuccess: () => {
            showSnackbar("Reminder deleted successfully", "success");
            queryClient.invalidateQueries({ queryKey: remindersQueryKeys.all });
        },
        onError: () => {
            showSnackbar("Failed to delete reminder", "error");
        },
    });

    return { createReminderMutation, updateReminderMutation, deleteReminderMutation };
};